module.exports = __webpack_public_path__ + "img/原理图文件名称.adecbcc6.svg";